import { callYqbExternalBrowser } from "@mgdx/shared/src/app-bridge/publisher";
import { type AnchorHTMLAttributes, type MouseEvent, useCallback } from "react";

import { useAppStatus } from "../providers/AppStatusProvider";
import { EXTERNAL_LINK_CONFIRMATION_TEXT } from "../utils/constants/externalLink";
import { useIsInMccmApp } from "./useIsInMccmApp";

export const useAppExternalLink = ({
  href,
  onClick,
  target = "_blank",
}: Pick<AnchorHTMLAttributes<HTMLAnchorElement>, "href" | "onClick" | "target">) => {
  const { isInApp, isInLineApp } = useAppStatus();
  const isInMccmApp = useIsInMccmApp();

  const onClickInLineApp = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();

      const result = window.confirm(EXTERNAL_LINK_CONFIRMATION_TEXT + "\n" + href);
      if (result) {
        window.open(href, "_blank");
      }

      onClick?.(e);
    },
    [href, onClick]
  );

  const onClickInMccmApp = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      if (!href) return;

      e.preventDefault();
      const url = new URL(href, process.env.MGDX_YQB_URL);
      callYqbExternalBrowser(url.toString());
      onClick?.(e);
    },
    [href, onClick]
  );

  if (isInLineApp) {
    return { href, target: "_self" as const, onClick: onClickInLineApp };
  }

  if (isInMccmApp) {
    return { href, target: "_self" as const, onClick: onClickInMccmApp };
  }

  return { href, target: isInApp ? ("_self" as const) : target, onClick };
};
